import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import EmbeddableFlipbook from '../../components/EmbeddableFlipbook';

/**
 * Widget Preview Page
 * Standalone page for iframe embeds
 */
const WidgetPreview = () => {
  const [searchParams] = useSearchParams();
  const [config, setConfig] = useState(null);

  useEffect(() => {
    const catalogId = searchParams?.get('catalogId');
    const width = searchParams?.get('width') || '100%';
    const height = searchParams?.get('height') || '800px';
    const responsive = searchParams?.get('responsive') !== 'false';
    const initialPage = parseInt(searchParams?.get('page')) || 1;
    const theme = searchParams?.get('theme') || 'light';
    const showNavigation = searchParams?.get('nav') !== '0';
    const showSharing = searchParams?.get('share') !== '0';
    const showZoom = searchParams?.get('zoom') !== '0';
    const showFullscreen = searchParams?.get('fullscreen') !== '0';

    if (!catalogId) {
      console.error('catalogId parameter is required');
      return;
    }

    setConfig({
      catalogId,
      width,
      height,
      responsive,
      initialPage,
      theme,
      showNavigation,
      showSharing,
      showZoom,
      showFullscreen,
      apiUrl: import.meta.env?.VITE_SUPABASE_URL || '',
      apiKey: import.meta.env?.VITE_SUPABASE_ANON_KEY || '',
      analyticsEnabled: true,
      ga4Id: import.meta.env?.VITE_GA_MEASUREMENT_ID || ''
    });
  }, [searchParams]);

  if (!config) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <p>Loading widget...</p>
      </div>
    );
  }

  return (
    <div style={{ width: '100vw', height: '100vh', margin: 0, padding: 0, overflow: 'hidden' }}>
      <EmbeddableFlipbook config={config} />
    </div>
  );
};

export default WidgetPreview;